import { c as _c } from "react/compiler-runtime";
import { Box, Divider, FormControl, IconButton, InputAdornment, InputLabel, ListSubheader, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { Dispatch, SetStateAction, useState, use } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganisationList } from '@/operations/queries/getOrganisationList';
import SearchIcon from '@mui/icons-material/Search';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import GlobalContext from '@/layout/Providers/GlobalContext';
import DotsLoader from '@/components/ui/DotsLoader';
export type OptionType = {
  value: string;
  title: string;
  disabled?: boolean;
};
const containsText = (text: string, searchText: string) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
const OrganisationSelector = () => {
  const $ = _c(84);
  const {
    role,
    currentOrganisation,
    organisations,
    setCurrentOrganisation,
    pageLoading
  } = use(GlobalContext);
  const {
    t
  } = useTranslation();
  const [searchText, setSearchText] = useState("");
  let t0;
  if ($[0] !== organisations) {
    t0 = organisations?.reduce(_temp, {}) || {};
    $[0] = organisations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const groupedData = t0;
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== currentOrganisation || $[3] !== groupedData || $[4] !== organisations || $[5] !== pageLoading || $[6] !== role || $[7] !== searchText || $[8] !== setCurrentOrganisation || $[9] !== t) {
    let t20;
    if ($[31] !== searchText) {
      t20 = option => containsText(option.name + "" + option.ta_supplier?.name, searchText);
      $[31] = searchText;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    const displayedOptions = organisations.filter(t20);
    const noItemSelected = !currentOrganisation?.id;
    const noItems = !organisations.length;
    const oneItem = organisations?.length === 1;
    const error = noItems && !pageLoading;
    let t21;
    if ($[33] !== noItems || $[34] !== t) {
      t21 = noItems ? t("styra.status.no_item", {
        item: t("styra.item.organisation_other")
      }) : t("styra.action.select_item", {
        item: t("styra.item.organisation_one")
      });
      $[33] = noItems;
      $[34] = t;
      $[35] = t21;
    } else {
      t21 = $[35];
    }
    const noneText = t21;
    T1 = FormControl;
    t17 = "standard";
    t18 = error;
    let t22;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = {
        lineHeight: 2.25
      };
      $[36] = t22;
    } else {
      t22 = $[36];
    }
    let t23;
    if ($[37] !== t) {
      t23 = t("styra.item.organisation_one", {
        capitalize: true
      });
      $[37] = t;
      $[38] = t23;
    } else {
      t23 = $[38];
    }
    if ($[39] !== t23) {
      t19 = <InputLabel id="organisation-select-label" sx={t22}>{t23}</InputLabel>;
      $[39] = t23;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    T0 = Select;
    t1 = oneItem || noItems;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        autoFocus: false,
        slotProps: {
          paper: {
            sx: {
              "& .MuiMenuItem-root": {
                padding: 1,
                fontSize: 13
              }
            }
          }
        }
      };
      $[41] = t2;
    } else {
      t2 = $[41];
    }
    t3 = "small";
    t4 = !error;
    t5 = true;
    t6 = "primary";
    t7 = "organisation-select-label";
    t8 = "organisation-select";
    t9 = noItems || noItemSelected ? "none" : currentOrganisation.id;
    if ($[42] !== setCurrentOrganisation) {
      t10 = e => {
        setCurrentOrganisation(e.target.value);
      };
      $[42] = setCurrentOrganisation;
      $[43] = t10;
    } else {
      t10 = $[43];
    }
    if ($[44] !== groupedData || $[45] !== noneText || $[46] !== pageLoading) {
      t11 = e_0 => {
        const none = e_0 === "none";
        return <Stack direction="row" spacing={0.5}>{pageLoading ? <Box sx={{
            width: 60
          }}><DotsLoader color="neutral.dark" size={6} /></Box> : <Typography sx={{
            color: none ? "neutral.dark" : "primary.main",
            fontSize: 15
          }}>{none ? noneText : `${groupedData[e_0]?.name}`}</Typography>}</Stack>;
      };
      $[44] = groupedData;
      $[45] = noneText;
      $[46] = pageLoading;
      $[47] = t11;
    } else {
      t11 = $[47];
    }
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = {
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "currentcolor"
        }
      };
      $[48] = t12;
    } else {
      t12 = $[48];
    }
    if ($[49] !== noItems || $[50] !== oneItem || $[51] !== pageLoading) {
      t13 = oneItem || pageLoading || noItems ? {
        IconComponent: _temp2
      } : undefined;
      $[49] = noItems;
      $[50] = oneItem;
      $[51] = pageLoading;
      $[52] = t13;
    } else {
      t13 = $[52];
    }
    let t24;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = {
        p: 1,
        mb: 1
      };
      $[53] = t24;
    } else {
      t24 = $[53];
    }
    let t25;
    if ($[54] !== searchText) {
      t25 = <SearchBar value={searchText} setValue={setSearchText} />;
      $[54] = searchText;
      $[55] = t25;
    } else {
      t25 = $[55];
    }
    let t26;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <Divider absolute={true} />;
      $[56] = t26;
    } else {
      t26 = $[56];
    }
    if ($[57] !== t25) {
      t14 = <ListSubheader sx={t24}><Stack spacing={1}>{t25}{t26}</Stack></ListSubheader>;
      $[57] = t25;
      $[58] = t14;
    } else {
      t14 = $[58];
    }
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <MenuItem sx={{
        display: "none"
      }} value="none" />;
      $[59] = t15;
    } else {
      t15 = $[59];
    }
    t16 = displayedOptions?.map(o => <MenuItem key={o.id} value={o.id}><Typography>{o.name} </Typography>{" "}{role !== "organisation_manager" ? <Typography sx={{
        color: "neutral.80",
        ml: 1
      }}>{o.ta_supplier?.name}</Typography> : null}</MenuItem>);
    $[2] = currentOrganisation;
    $[3] = groupedData;
    $[4] = organisations;
    $[5] = pageLoading;
    $[6] = role;
    $[7] = searchText;
    $[8] = setCurrentOrganisation;
    $[9] = t;
    $[10] = T0;
    $[11] = T1;
    $[12] = t1;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[10];
    T1 = $[11];
    t1 = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t14 = $[17];
    t15 = $[18];
    t16 = $[19];
    t17 = $[20];
    t18 = $[21];
    t19 = $[22];
    t2 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t20;
  if ($[60] !== T0 || $[61] !== t1 || $[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13 || $[66] !== t14 || $[67] !== t15 || $[68] !== t16 || $[69] !== t2 || $[70] !== t3 || $[71] !== t4 || $[72] !== t5 || $[73] !== t6 || $[74] !== t7 || $[75] !== t8 || $[76] !== t9) {
    t20 = <T0 disabled={t1} MenuProps={t2} size={t3} disableUnderline={t4} fullWidth={t5} color={t6} labelId={t7} id={t8} value={t9} onChange={t10} renderValue={t11} sx={t12} inputProps={t13}>{t14}{t15}{t16}</T0>;
    $[60] = T0;
    $[61] = t1;
    $[62] = t10;
    $[63] = t11;
    $[64] = t12;
    $[65] = t13;
    $[66] = t14;
    $[67] = t15;
    $[68] = t16;
    $[69] = t2;
    $[70] = t3;
    $[71] = t4;
    $[72] = t5;
    $[73] = t6;
    $[74] = t7;
    $[75] = t8;
    $[76] = t9;
    $[77] = t20;
  } else {
    t20 = $[77];
  }
  let t21;
  if ($[78] !== T1 || $[79] !== t17 || $[80] !== t18 || $[81] !== t19 || $[82] !== t20) {
    t21 = <T1 variant={t17} error={t18}>{t19}{t20}</T1>;
    $[78] = T1;
    $[79] = t17;
    $[80] = t18;
    $[81] = t19;
    $[82] = t20;
    $[83] = t21;
  } else {
    t21 = $[83];
  }
  return t21;
};
export default OrganisationSelector;
const SearchBar = t0 => {
  const $ = _c(17);
  const {
    value,
    setValue
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "& .MuiInputBase-root": {
        borderRadius: 999,
        fontSize: 12,
        lineHeight: 0,
        paddingLeft: 1,
        paddingRight: 1,
        paddingTop: 0,
        paddingBottom: 0,
        height: 24
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("styra.action.search");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== setValue) {
    t3 = e => setValue(e.target.value);
    $[3] = setValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: 16,
      marginRight: 0.8
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InputAdornment sx={t4} position="start"><SearchIcon fontSize="inherit" /></InputAdornment>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setValue || $[8] !== value) {
    t6 = value && <IconButton size="small" aria-label="clear search" onClick={() => setValue("")}><CancelRoundedIcon fontSize="inherit" /></IconButton>;
    $[7] = setValue;
    $[8] = value;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      input: {
        startAdornment: t5,
        endAdornment: t6
      }
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t7 || $[15] !== value) {
    t8 = <TextField autoFocus={true} fullWidth={true} sx={t1} placeholder={t2} type="text" variant="outlined" size="small" value={value} onChange={t3} onKeyDown={_temp3} slotProps={t7} />;
    $[12] = t2;
    $[13] = t3;
    $[14] = t7;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(acc, item) {
  return {
    ...acc,
    [item.id]: item
  };
}
function _temp2() {
  return null;
}
function _temp3(e_0) {
  if (e_0.key !== "Escape") {
    e_0.stopPropagation();
  }
}